(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("@fiverr/globals"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "@fiverr/globals"], factory);
	else if(typeof exports === 'object')
		exports["OutOfOffice"] = factory(require("react"), require("react-dom"), require("@fiverr/globals"));
	else
		root["OutOfOffice"] = factory(root["React"], root["ReactDOM"], root["@fiverr/globals"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_wLXD__, __WEBPACK_EXTERNAL_MODULE_E4I8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition